
import { Link } from "react-router-dom";
import { 
  CalendarIcon, 
  Users, 
  CheckSquare, 
  Kanban, 
  FolderClosed
} from "lucide-react";
import { useFeatureAccess, FeatureName } from "@/hooks/use-feature-access";

export function QuickAccess() {
  const { hasAccess } = useFeatureAccess();

  const quickLinks = [
    {
      title: "Adicionar Cliente",
      icon: Users,
      link: "/clients",
      color: "bg-blue-100 dark:bg-blue-900/30 text-blue-600 dark:text-blue-300",
      feature: "clients" as FeatureName
    },
    {
      title: "Tarefas",
      icon: CheckSquare,
      link: "/workflow",
      color: "bg-green-100 dark:bg-green-900/30 text-green-600 dark:text-green-300",
      feature: "workflow" as FeatureName
    },
    {
      title: "Calendário",
      icon: CalendarIcon,
      link: "/calendar",
      color: "bg-amber-100 dark:bg-amber-900/30 text-amber-600 dark:text-amber-300",
      feature: "calendar" as FeatureName
    },
    {
      title: "Kanban",
      icon: Kanban,
      link: "/workflow",
      color: "bg-indigo-100 dark:bg-indigo-900/30 text-indigo-600 dark:text-indigo-300",
      feature: "workflow" as FeatureName
    },
    {
      title: "Aprovações",
      icon: CheckSquare,
      link: "/approvals",
      color: "bg-orange-100 dark:bg-orange-900/30 text-orange-600 dark:text-orange-300",
      feature: "approvals" as FeatureName
    },
    {
      title: "Finanças",
      icon: FolderClosed,
      link: "/finances",
      color: "bg-emerald-100 dark:bg-emerald-900/30 text-emerald-600 dark:text-emerald-300",
      feature: "finances" as FeatureName
    }
  ];

  return (
    <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-5 xl:grid-cols-6 gap-3">
      {quickLinks.map((link, index) => {
        const featureEnabled = hasAccess(link.feature);
        
        if (featureEnabled) {
          return (
            <Link key={index} to={link.link} className="block">
              <div className="flex flex-col items-center gap-3 p-4 rounded-xl border hover:bg-muted/50 transition-all cursor-pointer shadow-sm hover:shadow">
                <div className={`p-3 rounded-full ${link.color}`}>
                  <link.icon className="h-5 w-5" />
                </div>
                <span className="font-medium text-center text-sm">{link.title}</span>
              </div>
            </Link>
          );
        }
      })}
    </div>
  );
}
